import type { Pagination, Product } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'products/products';

export function getProducts(query?: Product.SearchQuery) {
    return api.get<Pagination<Product>>(`${rootPath}`, query);
}

export function getProduct(id: number) {
    return api.get<Product.DetailsResponse>(`${rootPath}/${id}`, undefined);
}

export function postProduct(data: Product.CreateRequest) {
    return api.post<Product>(`${rootPath}`, data);
}

export function putProduct(id: number, data: Product.UpdateRequest) {
    return api.put<Product>(`${rootPath}/${id}`, data);
}

export function deleteProduct({ id }: Product.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
